import BaseService from "../BaseService";
import _ from "lodash";

class ImageService extends BaseService {
    upload = async (formdata) => {
        var image = this._api.post("store/image/upload", formdata)
        return image;
    };

    uploadFile = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        return  await this.upload(formData);
    };






 


}
export default ImageService;
